var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 -2)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16C7.464 16 4.001 11.74 4.001 10C4.001 7.999 7.46 4 12.001 4C16.377 4 19.999 7.973 19.999 10C19.999 11.74 16.537 16 12.001 16H12ZM12.001 2C6.48 2 2 6.841 2 10C2 13.086 6.576 18 12 18C17.423 18 22 13.086 22 10C22 6.841 17.52 2 12 2",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.977 11.984C10.874 11.984 9.977 11.087 9.977 9.984C9.977 8.881 10.874 7.984 11.977 7.984C13.081 7.984 13.977 8.881 13.977 9.984C13.977 11.087 13.081 11.984 11.977 11.984ZM11.977 5.984C9.771 5.984 7.977 7.778 7.977 9.984C7.977 12.19 9.771 13.984 11.977 13.984C14.184 13.984 15.977 12.19 15.977 9.984C15.977 7.778 14.184 5.984 11.977 5.984Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4829 3.30365L2.98685 17.9846",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3L4.26315 14.5266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.5c2e478c6f6c4860be343d46325cd66c.svg";
export { ForwardRef as ReactComponent };